import { Column } from '../../interface/colunas-tabelas.interface';

export const MOTIVO_PERDA_COLUMNS: Column[] = [
  {
    label: 'Resp',
    field: 'responsibleName',
    sortable: true,
    title: 'Responsável',
  },
  { label: 'ID', field: 'workId', sortable: true, title: 'Identificação' },
  { label: 'Emp', field: 'companyName', sortable: true, title: 'Empresa' },
  { label: 'Obra', field: 'workName', sortable: true, title: 'Nome da Obra' },
  {
    label: 'UF/Cid',
    field: 'stateName',
    sortable: true,
    title: 'Estado/Cidade',
  },

  { label: 'Tipo', field: 'workType', sortable: true, title: 'Tipo de Obra' },
  {
    label: 'Motivo',
    field: 'lastReason',
    sortable: true,
    title: 'Motivo',
  },
  {
    label: '\u0041\u00E7\u00E3\u006F',

    field: 'lastAction',
    sortable: true,
    title: '\u0041\u00E7\u00E3\u006F',
  },
  {
    label: 'Data',
    field: 'lastActionDate',
    sortable: true,
    title: 'Data',
  },
  {
    label: 'Relato',
    field: 'lastNote',
    sortable: true,
    title: 'Relato',
  },
  {
    label: 'Potenc',
    field: 'lastPotential',
    sortable: true,
    title: 'Potencial da obra',
  },
  {
    label: 'Vista',
    field: 'viewStatus',
    sortable: true,
    title: 'Status',
  },
  {
    label: 'Atr. em',
    field: 'assignedDate',
    sortable: true,
    title: 'Data de Atribui\u00e7\u00e3o',
  },
];
